/* acaciasupplies — consent.js · el banner de cookies con la Customer Privacy
   API de Shopify (lote seo-footer-legal, S3, 7 oct 2026). Lo carga
   `snippets/consent-banner`, diferido, en todas las rutas.

   QUÉ HACE
   · Pide la API a la plataforma: `Shopify.loadFeatures([{ name:
     'consent-tracking-api', version: '0.1' }], cb)`. Es lo único que se
     carga, y lo sirve cdn.shopify.com/shopifycloud/ (plataforma, no un
     tercero). Nada más sale a la red.
   · Con la API, DOS preguntas, no una. `shouldShowBanner()` dice si la
     REGIÓN del visitante exige consentimiento (en toda la UE, true), y sigue
     diciendo true DESPUÉS de elegir: medido en el live el 19 oct 2026 desde
     Barcelona (región ESCT): tras `setTrackingConsent` con todo a «no» —y
     también con todo a «yes»— `shouldShowBanner()` seguía en true, y el
     banner volvía en cada página. Lo que dice si el visitante YA ELIGIÓ es
     `currentVisitorConsent()`: `''` en cada campo = sin decisión; `yes` o
     `no` = decidido. Se enseña solo con las dos: región que exige y
     visitante sin decisión. Sin `currentVisitorConsent` en la API (el
     sustituto del fixture no lo trae), cuenta como sin decisión.
   · «Accept» → `setTrackingConsent({ analytics: true, marketing: false,
     preferences: true, sale_of_data: false })`; «Decline» → todo a false.
     `marketing` nunca se concede: el sitio no tiene cookies de marketing y
     el banner solo pide analítica (lo que dice /pages/cookies). Shopify
     guarda la elección y la reparte a píxeles y apps. Al confirmar, el
     banner se esconde.
   · Un enlace con `data-consent-open` (en /pages/cookies) vuelve a enseñar
     el banner; sin API, el enlace hace lo que dice su `href`.

   SIN API NO PASA NADA, Y A PROPÓSITO. El motor local de los fixtures no
   tiene `window.Shopify`; una tienda sin la exigencia de consentimiento
   devuelve `shouldShowBanner() === false`. En los dos casos el banner sigue
   `hidden` desde el servidor, sin error de consola. El fixture
   (`scripts/qa/fixtures/legal-pages.mjs`) inyecta un `Shopify` de mentira
   para probar los dos botones.

   Un error de la API se registra con `console.warn` y el banner se queda
   abierto (regla 12 de CLAUDE.md: nada se descarta en silencio; un `catch`
   mudo que escondiera el banner diría «elegido» donde no se eligió nada). */
(function (w, d) {
  'use strict';

  var as = w.acaciasupplies = w.acaciasupplies || {};
  if (as.consent) return;

  var banner = d.querySelector('[data-consent-banner]');
  if (!banner) return;

  var accept = banner.querySelector('[data-consent-accept]');
  var decline = banner.querySelector('[data-consent-decline]');
  var api = null;

  function warn(what, err) {
    console.warn('consent: ' + what, err);
  }

  function show(focus) {
    banner.hidden = false;
    if (focus && accept) accept.focus();
  }

  function hide() {
    banner.hidden = true;
  }

  function choose(granted) {
    if (!api) return;
    api.setTrackingConsent(
      { analytics: granted, marketing: false, preferences: granted, sale_of_data: false },
      function (result) {
        if (result && result.error) {
          warn('setTrackingConsent failed', result.error);
          return;
        }
        hide();
      }
    );
  }

  function decided() {
    if (!api || typeof api.currentVisitorConsent !== 'function') return false;
    var consent = api.currentVisitorConsent() || {};
    return ['analytics', 'marketing', 'preferences'].some(function (key) {
      return consent[key] === 'yes' || consent[key] === 'no';
    });
  }

  function ready() {
    api = w.Shopify && w.Shopify.customerPrivacy;
    if (!api || typeof api.shouldShowBanner !== 'function') return;
    if (api.shouldShowBanner() && !decided()) show(false);
  }

  if (accept) accept.addEventListener('click', function () { choose(true); });
  if (decline) decline.addEventListener('click', function () { choose(false); });

  d.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('[data-consent-open]') : null;
    if (!target || !api) return;
    event.preventDefault();
    show(true);
  });

  if (w.Shopify && typeof w.Shopify.loadFeatures === 'function') {
    w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) {
        warn('loadFeatures failed', error);
        return;
      }
      ready();
    });
  } else if (w.Shopify && w.Shopify.customerPrivacy) {
    ready();
  }

  as.consent = { show: show, hide: hide };
})(window, document);
